<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3885_15116)">
      <path
        d="M7.99998 14.6666C9.84091 14.6666 11.5076 13.9204 12.714 12.714C13.9204 11.5076 14.6666 9.84091 14.6666 7.99998C14.6666 6.15905 13.9204 4.49238 12.714 3.28593C11.5076 2.07951 9.84091 1.33331 7.99998 1.33331C6.15905 1.33331 4.49238 2.07951 3.28593 3.28593C2.07951 4.49238 1.33331 6.15905 1.33331 7.99998C1.33331 9.84091 2.07951 11.5076 3.28593 12.714C4.49238 13.9204 6.15905 14.6666 7.99998 14.6666Z"
        fill="#d93025"
        stroke="#d93025"
        stroke-width="1.33333"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.00002 12.3334C8.46025 12.3334 8.83335 11.9603 8.83335 11.5C8.83335 11.0398 8.46025 10.6667 8.00002 10.6667C7.53979 10.6667 7.16669 11.0398 7.16669 11.5C7.16669 11.9603 7.53979 12.3334 8.00002 12.3334Z"
        fill="white"
      />
      <path
        d="M8 4V9.33333"
        stroke="white"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3885_15116">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
